import { render } from '@arr2019/app-libs';
import { ViewMain } from './views/main/view.js';
import { initStats } from './lib/stats.js';
import { LuminMystic } from '@arr2019/lumin-mystic';

const myAmbientHandler = new LuminMystic({
  storageContext: 'session',
  classDark: 'is-dark',
  eventFn: () => true
});
myAmbientHandler.init();

initStats();
render(ViewMain(), document.getElementById('app'));
